import * as React from 'react';
import { useState, useRef } from 'react';
import { useKeyListener } from '../hooks/useKeyListener';
import { Image } from '../types/Media';

interface LightboxProps {
    images: Image[];
    shown: boolean;
    setShown: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Lightbox: React.FC<LightboxProps> = ({ images, shown, setShown }) => {
    const [index, setIndex] = useState(0);
    const container = useRef<HTMLDivElement>();

    useKeyListener({
        ArrowRight: () => shown && adjustIndex(1),
        ArrowLeft: () => shown && adjustIndex(-1),
        Escape: () => setShown(false),
    }, () => shown);

    const handleOutsideClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === container.current) {
            setShown(false);
            setIndex(0);
        }
    };

    const adjustIndex = (amount: number) => {
        const maxIndex = images.length - 1;
        let newIndex = index + amount;

        if (newIndex < 0) {
            newIndex = maxIndex;
        }

        if (newIndex > maxIndex) {
            newIndex = 0;
        }

        setIndex(newIndex);
    }

    const handleImageChange = (amount: number) => (e: React.MouseEvent) => {
        e.preventDefault();

        adjustIndex(amount);
    };

    return shown ? (
        <div ref={container} className="image-popout" onClick={handleOutsideClick}>
            {images.length > 1 ? (
                <a href="#" className="handle" onClick={handleImageChange(-1)}>
                    <img src="/_shared/img/angle_left.svg" />
                </a>
            ) : null}

            <div className="image-container">
                <img className="image" src={images[index].url} />
                <p className="image-caption">Image {index + 1} of {images.length}</p>
            </div>

            {images.length > 1 ? (
                <a href="#" className="handle" onClick={handleImageChange(1)}>
                    <img src="/_shared/img/angle_right.svg" />
                </a>
            ) : null}
        </div>
    ) : null;
};

Lightbox.displayName = 'Lightbox';
